module.exports = __webpack_public_path__ + "media/jegesmedve_m.23b7f9fa.mp3";